import { useEffect } from 'react';
import { useSelector } from 'react-redux';

/* global snaptr */

const SnapPixel = ({ userEmail = '' }) => {

    const { user } = useSelector((state) => state.auth);

    useEffect(() => {
        (function (e, t, n) {
            if (e.snaptr) return;
            const a = (e.snaptr = function () {
                a.handleRequest
                    ? a.handleRequest.apply(a, arguments)
                    : a.queue.push(arguments);
            });
            a.queue = [];
            const s = 'script';
            const r = t.createElement(s);
            r.async = true;
            r.src = n;
            const u = t.getElementsByTagName(s)[0];
            u.parentNode.insertBefore(r, u);
        })(window, document, 'https://sc-static.net/scevent.min.js');

        if (typeof snaptr !== 'undefined') {
            snaptr('init', process.env.REACT_APP_SNAP_PIXEL_ID, {
                user_email: user?.email,
            });
            snaptr('track', 'PAGE_VIEW');
        }
    }, [userEmail , user]);

    return null;
};


export const trackSnapEvent = (eventName, data = {}) => {
    if (typeof window.snaptr !== 'undefined') {
        window.snaptr('track', eventName, data);
    } else {
        console.warn(`[Snap Pixel] Event "${eventName}" not fired — snaptr not available`);
    }
};

export default SnapPixel;
